import { authenticatedGuard } from '@/guards/authenticated.guard';
import { unauthenticatedGuard } from '@/guards/unauthenticated.guard';
import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'main', pathMatch: 'full' },
  {
    path: 'main',
    loadComponent: () => import('./pages/main/main.component').then((m) => m.MainComponent),
    canActivate: [authenticatedGuard],
  },
  {
    path: 'auth',
    loadComponent: () => import('./pages/auth/auth.component').then((m) => m.AuthComponent),
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        loadComponent: () => import('./pages/auth/login/login.component').then((m) => m.LoginComponent),
        canActivate: [unauthenticatedGuard],
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
        canActivate: [unauthenticatedGuard],
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./pages/auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
        canActivate: [unauthenticatedGuard],
      },
      {
        path: 'invalid-role',
        loadComponent: () =>
          import('./pages/auth/invalid-role/invalid-role.component').then((m) => m.InvalidRoleComponent),
      },
    ],
  },
  {
    path: 'styleguide',
    loadComponent: () => import('./pages/styleguide/styleguide.component').then((m) => m.StyleguideComponent),
  },
];
